import { Modal } from "@scandotcom/react";
import React from "react";
import type { LocationResult, ScanType } from "../types";
import { AvailabilityModalContent } from "./AvailabilityModalContent";

export interface AvailabilityModalProps
  extends Omit<React.ComponentProps<typeof Modal>, "children"> {
  scanningCenter: Pick<
    LocationResult,
    "id" | "name" | "next_day_surcharge" | "price"
  > | null;
  modality?: ScanType;
  bodyPartIds: number[];
  searchId: string;
  daySelected?: string;
  hidePrices?: boolean;
}

export function AvailabilityModal({
  scanningCenter,
  onClose,
  modality,
  bodyPartIds,
  searchId,
  daySelected = "",
  hidePrices,
  ...props
}: AvailabilityModalProps) {
  return (
    <Modal
      onClose={onClose}
      {...props}
      className="w-full sm:max-w-xl"
      transition="left"
    >
      {scanningCenter && modality && bodyPartIds.length > 0 ? (
        <AvailabilityModalContent
          selectedScanType={modality}
          selectedBodyPartIds={bodyPartIds}
          scanningCenter={scanningCenter}
          onClose={onClose}
          searchId={searchId}
          daySelected={daySelected}
          hidePrices={hidePrices}
        />
      ) : null}
    </Modal>
  );
}
